// extracted by mini-css-extract-plugin
export var formationVideo = "FormationVideo-module--formationVideo--yLkDF";
export var formationVideo__image = "FormationVideo-module--formationVideo__image--IOIht";
export var formationVideo__video = "FormationVideo-module--formationVideo__video--PXula";
export var tkMyriadProSemiCondensed = "FormationVideo-module--tk-myriad-pro-semi-condensed--sXo5K";